import { render } from "./MainFrontLayout.vue?vue&type=template&id=110ed228&scoped=true"
import script from "./MainFrontLayout.vue?vue&type=script&lang=js"
export * from "./MainFrontLayout.vue?vue&type=script&lang=js"

import "./MainFrontLayout.vue?vue&type=style&index=0&id=110ed228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110ed228"]])

export default __exports__